// Base URL of a commission's Distribution tab. Client Fees/Charges commissions
// have no case or payment, so their distributions sit directly under the fee.
export const getDistributionBasePath = ({
  clientId,
  section,
  caseTypeSegment = "",
  caseId,
  subItem = "payments",
  subItemId,
  subSubItemId,
}: {
  clientId?: string;
  section?: string;
  caseTypeSegment?: string;
  caseId?: string;
  subItem?: string;
  subItemId?: string;
  subSubItemId?: string;
}) =>
  section === "fees-charges"
    ? `/clients/${clientId}/fees-charges/${subSubItemId}/distribution`
    : `/clients/${clientId}/${section}${caseTypeSegment}/${caseId}/${subItem}/${subItemId}/commission/${subSubItemId}/distribution`;
